import { render, staticRenderFns } from "./ChooseSkill.vue?vue&type=template&id=28d2363a"
import script from "./ChooseSkill.vue?vue&type=script&lang=ts"
export * from "./ChooseSkill.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports